import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';

import Loading from '../../components/loading';
import GA from '../../helpers/ga';

import {loginWithBigcommerce} from './actions';

const PAGE_VIEW_NAME = '/callback/bigcommerce/auth';

export class CallbackBigcommerceAuthPage extends React.Component {
	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillMount() {
		const getParams = queryString.parse(this.props.location.search);
		this.props.loginWithBigcommerce(getParams);
	}

	render() {
		return <Loading />;
	}
}

export function mapsStateToProps(state) {
	return {};
}

export function mapsDispatchToProps(dispatch) {
	return {
		loginWithBigcommerce(params) {
			dispatch(loginWithBigcommerce(params));
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)(CallbackBigcommerceAuthPage);



// WEBPACK FOOTER //
// ./src/containers/callback-bigcommerce-auth-page/index.js